var map = {
	"./dark/GlobeOil/header-background.svg": "./src/views/eternal-dev/businesses/gas-station/images/dark/GlobeOil/header-background.svg",
	"./dark/GlobeOil/logo.svg": "./src/views/eternal-dev/businesses/gas-station/images/dark/GlobeOil/logo.svg",
	"./dark/LimitedLtd/header-background.svg": "./src/views/eternal-dev/businesses/gas-station/images/dark/LimitedLtd/header-background.svg",
	"./dark/LimitedLtd/logo.svg": "./src/views/eternal-dev/businesses/gas-station/images/dark/LimitedLtd/logo.svg",
	"./dark/Ron/header-background.svg": "./src/views/eternal-dev/businesses/gas-station/images/dark/Ron/header-background.svg",
	"./dark/Ron/logo.svg": "./src/views/eternal-dev/businesses/gas-station/images/dark/Ron/logo.svg",
	"./dark/XEro/header-background.svg": "./src/views/eternal-dev/businesses/gas-station/images/dark/XEro/header-background.svg",
	"./dark/XEro/logo.svg": "./src/views/eternal-dev/businesses/gas-station/images/dark/XEro/logo.svg",
	"./dark/scale-background.svg": "./src/views/eternal-dev/businesses/gas-station/images/dark/scale-background.svg",
	"./light/GlobeOil/header-background.svg": "./src/views/eternal-dev/businesses/gas-station/images/light/GlobeOil/header-background.svg",
	"./light/GlobeOil/logo.svg": "./src/views/eternal-dev/businesses/gas-station/images/light/GlobeOil/logo.svg",
	"./light/LimitedLtd/header-background.svg": "./src/views/eternal-dev/businesses/gas-station/images/light/LimitedLtd/header-background.svg",
	"./light/LimitedLtd/logo.svg": "./src/views/eternal-dev/businesses/gas-station/images/light/LimitedLtd/logo.svg",
	"./light/Ron/header-background.svg": "./src/views/eternal-dev/businesses/gas-station/images/light/Ron/header-background.svg",
	"./light/Ron/logo.svg": "./src/views/eternal-dev/businesses/gas-station/images/light/Ron/logo.svg",
	"./light/XEro/header-background.svg": "./src/views/eternal-dev/businesses/gas-station/images/light/XEro/header-background.svg",
	"./light/XEro/logo.svg": "./src/views/eternal-dev/businesses/gas-station/images/light/XEro/logo.svg",
	"./light/scale-background.svg": "./src/views/eternal-dev/businesses/gas-station/images/light/scale-background.svg",
	"./scale-mask.svg": "./src/views/eternal-dev/businesses/gas-station/images/scale-mask.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/views/eternal-dev/businesses/gas-station/images sync recursive \\.svg$";